<template>
  <div v-if="buyChannel != null">
    <!-- 基本資料 -->
    <div class="block">
      <!-- 基本資料 -->
      <div class="px-5 pt-5">
        <h3>基本資料</h3>
      </div>
      <!-- 選擇通路形式 -->
      <div class="form-item py-5 d-flex">
        <div class="w-220px mr-8">
          <h4>選擇通路形式</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 mt-n1 mb-n2">
          <v-radio-group v-model="buyChannel.type" row>
            <v-radio
              v-for="item in channelOptions"
              :key="item.value"
              :label="`Radio ${item.value}`"
              :value="item.value"
              class="mb-5"
            >
              <template v-slot:label>
                <div
                  class="h5 ink-01-emphasis--text h-20px w-150px d-flex align-center"
                >
                  {{ item.text }}
                </div>
              </template></v-radio>
          </v-radio-group>
        </div>
      </div>
      <!-- 通路名稱 -->
      <label class="form-item pt-5 d-flex">
        <div class="w-220px mr-8">
          <h4>通路名稱</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="buyChannel.title"
            placeholder="請輸入通路名稱"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- BU -->
      <label class="form-item pt-5 d-flex">
        <div class="w-220px mr-8">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="buyChannel.bu_id"
            :items="buTabs"
            placeholder="請選擇所屬BU"
            item-text="name"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </label>
      <!-- Order -->
      <label class="form-item pt-5 d-flex">
        <div class="w-220px mr-8">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="buyChannel.order"
            placeholder="請輸入序號"
            class="w-248px"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div>
          <FormSwitch v-model="buyChannel.status"></FormSwitch>
        </div>
      </label>
      <!-- 通用導連網址 -->
      <label class="form-item pt-5 d-flex">
        <div class="w-220px mr-8">
          <h4>通用導連網址</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="buyChannel.url"
            placeholder="請輸入導購網址"
            prepend-inner-icon="mdi-link"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 通路國家 -->
      <label
        class="form-item py-5 d-flex"
        v-if="!(buyChannel.type === 2 || buyChannel.type === 5)"
      >
        <div class="w-220px mr-8">
          <h4>通路國家</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="where-to-buy-autocomplete">
            <MultiSelectWithCheckbox
              v-model="buyChannel.countries"
              :items="buycountries"
              placeholder="請選擇國家 (複選)"
              item-value="id"
              item-text="name"
            ></MultiSelectWithCheckbox>
          </div>
        </div>
      </label>
      <!-- 通路STATE -->
      <label
        class="form-item py-5 d-flex"
        v-if="!(buyChannel.type === 2 || buyChannel.type === 5)"
      >
        <div class="w-220px mr-8">
          <h4>通路 state</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="where-to-buy-autocomplete">
            <v-autocomplete
              v-model="buyChannel.state_id"
              :items="buyState"
              placeholder="請選擇所屬STATE"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- Logo -->
      <div class="form-item py-5 d-flex">
        <div class="w-220px mr-8">
          <h4 class="mb-10px">Logo</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="buyChannel.logo"
            :dir="'where_to_buy'"></ImgUploader>
        </div>
      </div>
      <!-- show when pathway offlie -->
      <div v-if="buyChannel.type === 2 || buyChannel.type === 5">
        <!-- 通路國家 -->
        <label class="form-item py-5 d-flex">
          <div class="w-220px mr-8">
            <h4>通路國家</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <MultiSelectWithCheckbox
              v-model="buyChannel.countries"
              :items="buycountries"
              placeholder="請選擇國家 (複選)"
              item-value="id"
              item-text="name"
            ></MultiSelectWithCheckbox>
          </div>
        </label>
        <!-- 通路地址 -->
        <label class="form-item pt-5 d-flex">
          <div class="w-220px mr-8">
            <h4>通路地址</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="buyChannel.address"
              placeholder="請輸入通路地址"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- 電話 -->
        <label class="form-item pt-5 d-flex">
          <div class="w-220px mr-8">
            <h4>電話</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="buyChannel.phone"
              placeholder="請輸入電話"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- Email -->
        <label class="form-item pt-5 d-flex">
          <div class="w-220px mr-8">
            <h4>Email</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="buyChannel.email"
              placeholder="請輸入電子郵件"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- 上傳電子型錄 -->
        <div class="form-item py-5 d-flex">
          <div class="w-220px mr-8">
            <h4 class="mb-10px">上傳電子型錄</h4>
            <div class="h5 ink-02-medium--text">
              建議檔案格式：PDF <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FileUploader
              v-model="buyChannel.pdf"
              :dir="'where_to_buy'"></FileUploader>
          </div>
        </div>
      </div>
    </div>

    <div class="page-divider my-5"></div>

    <!-- 添加產品型號 -->
    <div class="d-flex">
      <div class="w-300px mr-5">
        <h3 class="mb-10px">添加產品型號</h3>
        <div>
          有勾選的產品型號才會出現通路資訊 <br />
          導連網址處若為空白，將自動帶入「通用導連網址」
        </div>
      </div>
      <!-- 產品呈現區 -->
      <div class="flex-grow-1 flex-basis-0">
        <!-- 添加產品 -->
        <div class="brand-100 h-64px px-5 d-flex align-center">
          <h4 class="mr-8">添加產品</h4>
          <div class="where-to-buy-autocomplete flex-grow-1">
            <v-autocomplete
              :items="categories"
              v-model="tempCategory"
              placeholder="搜尋Category Name"
              item-value="id"
              item-text="name"
              return-object
              outlined
              dense
            >
            </v-autocomplete>
          </div>
          <button
            v-if="tempCategory"
            class="btn btn-primary w-90px ml-5"
            @click="addCategory"
          >
            新增
          </button>
          <button v-else class="btn btn-primary w-90px ml-5" disabled>
            新增
          </button>
        </div>
        <!-- 分類名稱與底下產品 -->
        <div class="block">
          <div
            v-for="(categoryItem, i) in buyChannel.categories"
            :key="categoryItem.category"
          >
            <!-- categoryName -->
            <div
              class="form-item d-flex h-64px align-center justify-space-between"
            >
              <h4>{{ categoryItem.name }}</h4>
              <button class="btn square" @click="clickCategory(i)">
                <v-icon>ALL</v-icon>
              </button>
              <button class="btn square" @click="deleteCategory(i)">
                <v-icon>delete</v-icon>
              </button>
            </div>
            <!-- products -->
            <div class="form-item mt-5">
              <div
                v-for="product in categoryItem.products"
                :key="product.id"
              >
                <!-- productName -->
                <div>
                  <v-checkbox v-model="product.isChecked">
                    <template v-slot:label>
                      <div class="h5 ink-01-emphasis--text">
                        {{ product.text }}
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <!-- link -->
                <div class="ml-7" v-if="product.isChecked">
                  <v-text-field
                    v-model="product.url"
                    prepend-inner-icon="mdi-link"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormSwitch from '@/components/FormSwitch.vue';
import { mapState, mapActions } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    MultiSelectWithCheckbox,
    FileUploader,
  },
  data() {
    return {
      categories: [],
      // 添加產品型號
      tempCategory: null,
    };
  },
  computed: {
    ...mapState(['buTabs']),
    ...mapState('language', ['countries', 'buycountries']),
    ...mapState('buyChannel', ['buyChannel', 'channelOptions', 'buyState']),
  },
  watch: {
    async 'buyChannel.bu_id'() {
      this.categories = await this.allByBu(this.buyChannel.bu_id);
    },
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    addCategory() {
      const hasCategory =
        this.buyChannel.categories.find((category) => category.id === this.tempCategory.id);
      if (hasCategory) {
        this.tempCategory = null;
        return;
      }

      const { id, name } = this.tempCategory;
      const tempProducts = this.tempCategory.products;

      const products = tempProducts.map((product) => {
        product.isChecked = true;
        product.url = '';
        return product;
      });

      const template = {
        id, name, products,
      };

      this.buyChannel.categories.push(JSON.parse(JSON.stringify(template)));
      this.tempCategory = null;
    },
    deleteCategory(i) {
      this.buyChannel.categories.splice(i, 1);
    },
    clickCategory(i) {
      this.buyChannel.categories[i].products.map((product) => {
        product.abc = product.id;
        if (product.isChecked !== true) {
          product.isChecked = true;
        }
        if (!product.url) {
          product.url = this.buyChannel.url;
        }
        return product;
      });
    },
  },
};
</script>

<style lang="scss">
.where-to-buy-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    background: white;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
    font-size: 16px;
    line-height: 1.43;
  }
}
</style>
